import { consumeImpersonationFromUrl } from "./impersonation";

/**
 * Side-effect module: adopt an impersonation session handed over via the URL
 * fragment (`#impersonate=...`) and strip the fragment — BEFORE anything else
 * in the app evaluates.
 *
 * Must be the FIRST import in the entry module (`src/index.tsx`). The router is
 * created at module-import time (`createBrowserRouter` in `src/routes/routes.tsx`,
 * pulled in transitively by `import App`), so it captures `window.location` as
 * soon as that module graph evaluates. Running the fragment strip here — before
 * the `App` import is reached — guarantees the router (and the very first API
 * request) sees the already-stripped, session-seeded URL. Calling it later (in
 * the entry body) would let the router capture the raw `#impersonate=...` URL
 * and re-apply the fragment on the first scoped navigation.
 */
consumeImpersonationFromUrl();
